module.exports = __webpack_public_path__ + "static/media/pse.9671eb79.svg";